import React from 'react';
import styles from './AuthFooter.module.less';

// Shared footer for the auth pages (login, password-reset, SSO-error). Markup +
// styling ported from the prod login.html list-inline footer.
const AuthFooter = () => (
  <footer className={styles.footer}>
    <ul>
      <li>
        <a href="https://pipl.com/product-tos/" target="_blank" rel="noopener noreferrer">
          Terms
        </a>
      </li>
      <li>|</li>
      <li>
        <a href="https://pipl.com/privacy/" target="_blank" rel="noopener noreferrer">
          Privacy
        </a>
      </li>
      <li>|</li>
      <li>
        <a href="https://pipl.com/customer-support" target="_blank" rel="noopener noreferrer">
          Contact
        </a>
      </li>
      <li>|</li>
      <li>
        <p className={styles.copyright}>© 2006-{new Date().getFullYear()} pipl</p>
      </li>
    </ul>
  </footer>
);

export default AuthFooter;
